import { Outlet } from 'react-router-dom';

import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const NoCardRouteLayout = () => {
  return (
    <RequireAuth redirectTo="signup">
      <Outlet />
    </RequireAuth>
  );
};
export default NoCardRouteLayout;
